import { render, staticRenderFns } from "./AvatarStack.vue?vue&type=template&id=6e9ae85e&scoped=true&lang=pug"
import script from "./AvatarStack.vue?vue&type=script&lang=js"
export * from "./AvatarStack.vue?vue&type=script&lang=js"
import style0 from "./AvatarStack.vue?vue&type=style&index=0&id=6e9ae85e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ae85e",
  null
  
)

export default component.exports